module.exports = __webpack_public_path__ + "static/media/sound_8.ba510d3d.mp3";